import React, { useMemo } from "react";
import { getSolutionNomDeProposition } from "./helpers";
import { AccessoireItem } from "./SolutionAccessoires";
import { SolutionSummaryItem } from "./SolutionDetailComponents/SolutionSummaryItem";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";

export const BasketSummary: React.FC<{
  panierItems: AccessoireItem[];
  serviceItems: AccessoireItem[];
  accessoireItems: AccessoireItem[];
  boilerItems: AccessoireItem[];
  selectedAccessoiresNonSupp: Record<string, boolean>;
  selectedServices: Record<string, boolean>;
  selectedAccessoiresSupp: Record<string, number | undefined>;
  selectedBoilers: Record<string, boolean>;
  solution: Solution;
}> = ({
  panierItems,
  serviceItems,
  accessoireItems,
  boilerItems,
  selectedAccessoiresNonSupp,
  selectedServices,
  selectedAccessoiresSupp,
  selectedBoilers,
  solution,
}) => {
  const { network } = useSalesNetwork();
  const footerItems = useMemo(() => {
    const pacItem = panierItems.find((item) => item.tag == "HP");
    const pacPrice = pacItem ? pacItem.prix * pacItem.quantite : 0;

    const productPrice = panierItems.reduce(
      (sum, item) => sum + (item.tag == "HP" ? 0 : item.prix * item.quantite),
      0
    );
    const fixedQuantityPriceCalculation = (
      items: AccessoireItem[],
      selectedItems: Record<string, boolean>
    ) => {
      return items.reduce((sum, item) => {
        const { code, prix, quantite } = item;
        if (selectedItems[code]) {
          sum += quantite * prix;
        }
        return sum;
      }, 0);
    };
    const servicePrice = fixedQuantityPriceCalculation(
      serviceItems,
      selectedServices
    );
    const boilerPrice = fixedQuantityPriceCalculation(
      boilerItems,
      selectedBoilers
    );
    const accessoireNonSuppPrice = fixedQuantityPriceCalculation(
      accessoireItems.filter((acc) => acc.tag !== "SUPP"),
      selectedAccessoiresNonSupp
    );

    const accessoiresSuppPrice = accessoireItems
      .filter((acc) => acc.tag == "SUPP")
      .reduce((sum, accessoire) => {
        const { code, prix } = accessoire;
        if (selectedAccessoiresSupp[code]) {
          sum += selectedAccessoiresSupp[code] * prix;
        }
        return sum;
      }, 0);
    const accessoirePrice =
      accessoireNonSuppPrice +
      accessoiresSuppPrice +
      servicePrice +
      boilerPrice;

    return [
      {
        image: pacItem?.previewUrl,
        title: "FO_ACC_PRICE_PAC",
        name: getSolutionNomDeProposition(solution),
        price: pacPrice,
      },
      {
        title: "FO_ACC_PRICE_ACC_NECESSARY",
        name: "FO_ACC_PRICE_ACC_TOTAL",
        price: productPrice,
      },
      {
        title: "FO_ACC_PRICE_ACC_SUPP",
        name: "FO_ACC_PRICE_ACC_TOTAL",
        price: accessoirePrice,
      },
      {
        title: "FO_ACC_PRICE_BUDGET",
        name: "FO_ACC_PRICE_TOTAL",
        price: pacPrice + accessoirePrice + productPrice,
        isTotal: true,
      },
    ];
  }, [
    panierItems,
    serviceItems,
    accessoireItems,
    selectedServices,
    selectedAccessoiresSupp,
    selectedAccessoiresNonSupp,
    boilerItems,
    selectedBoilers,
  ]);
  return (
    <group id="footerItems" data-wrap="no" data-overflow="scroll">
      {network?.showPrice &&
        footerItems.map((item) => (
          <SolutionSummaryItem key={item.title} {...item} />
        ))}
    </group>
  );
};
